import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';

const Row = styled.div`
  display: grid;
  height: ${({ height }) => height || 'min-content'};
  grid-column-gap: ${({ gutter }) => gutter || '8px'};
  margin-top: ${({ marginTop }) => marginTop || '0px'};
  margin-bottom: ${({ marginBottom }) => marginBottom || '8px'};

  ${ifProp('span', ({ start, span }) => {
    if (start) {
      return `grid-column: ${start} / span ${span} !important;`;
    }

    return `grid-column: span ${span} !important;`;
  })}

  ${ifProp(
    'noGutter',
    () => css`
      grid-column-gap: 0;
    `
  )}

	grid-template-columns: ${({ columns }) => `repeat(${columns || '16'}, 1fr)`};

  ${ifProp('alignItems', ({ alignItems }) => `align-items: ${alignItems};`)};

  ${ifProp('outline', () => `outline: solid blue 1px;`)};

  > * {
    grid-column: 1 / -1;
  }
`;

export default Row;
